/**
 * F18.10 — Bootstrap globale dei tour onboarding.
 *
 * Montato in App.tsx una volta sola (dentro Auth + Organization provider).
 * Side effect:
 *  - Auto-launch welcome al primo login (via useTours useEffect interno)
 *  - Backward-compat localStorage v1 → DB v2 (via useTours useEffect interno)
 *  - Deep-link `?tour=<id>` per lanciare un tour da email/chat
 *
 * Nessun output visuale.
 */
import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTours } from './useTours';
import { TOUR_META, type TourId } from './types';

const TourBootstrap: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { startTour, isMobile } = useTours();
  const deepLinkHandledRef = useRef(false);

  // Deep-link: `?tour=configurator-wall` → lancia il tour e rimuovi il param
  useEffect(() => {
    if (deepLinkHandledRef.current) return;
    if (isMobile) return;
    const tourParam = searchParams.get('tour') as TourId | null;
    if (!tourParam) return;
    if (!Object.keys(TOUR_META).includes(tourParam)) return;
    deepLinkHandledRef.current = true;
    // Delay 1s per dare tempo all'app di stabilizzarsi
    const t = window.setTimeout(() => {
      void startTour(tourParam);
      // Pulisci il param senza ricaricare
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);
        next.delete('tour');
        return next;
      }, { replace: true });
    }, 1000);
    return () => window.clearTimeout(t);
  }, [searchParams, setSearchParams, startTour, isMobile]);

  return null;
};

export default TourBootstrap;
